import {Avatar,Badge, Box, Button, Card,Chip,IconButton, Modal, Skeleton, Stack,Switch, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { isMobile } from 'react-device-detect';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Swal from 'sweetalert2';

import DeleteIcon from '@mui/icons-material/Delete';
import { PermissionGuard } from '../../../components/PermissionGuard';
import dayjs from 'dayjs';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { useNavigate } from 'react-router-dom';
import { ArrowBack, Edit } from '@mui/icons-material';
import { BannerServices } from './BannerServices';
import { useForm } from 'react-hook-form';
import Loading from '../../../components/Loader/Loading';
import { formatDateTime } from '../../../utils/dateUtils';
import MultiColumnFilter from '../../../components/Filter/MultiColumnFilter';
import ExportAll from '../rewardPrograms/ExportAll';
import QuickSearchTool from '../../../components/QuickSearch/QuickSearchTool';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import useResponsive from '../../../hooks/useResponsive';

const style = {
    position: 'absolute',
    top: (isMobile) ? '80%' : '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #ddd',
    boxShadow: 24,
    // p: 2,
};


const AllBanners = () => {
  const {isSm} = useResponsive();
  const navigate = useNavigate();
  const { control, handleSubmit, reset, setValue, getValues, formState: { errors } } = useForm({
    mode: "onChange"
  });
  const [allRowCount, setAllRowCount] = useState(0);
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
      page: 0,
      pageSize: 50,
      filters: {
        searchKey: "",
        sortBy:'createdAt',
        sortType:'desc',
        filterOptions: []
      }
  });
  const [loading, setLoading] = useState(false);
  const fetchBannerList = async ()=>{
    try {
      setLoading(true)
      const listResponse = await BannerServices.bannerList({
        page: paginationModel.page,
        limit: paginationModel.pageSize,
        filters: {
          searchKey: paginationModel.filters.searchKey,
          sortBy: paginationModel.filters.sortBy,
          sortType: paginationModel.filters.sortType,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      });
      console.log("Banner list Response:",listResponse)
      setValue('status', paginationModel.filters.status)
      if (listResponse.success=='1') {
        setList(listResponse.data.list);
        setAllRowCount(listResponse.data.totalItems);
      } 
      else {
      //   Swal.fire('Request failed','','error')
      }
    } catch (error) {
      Swal.fire(error.message,'','error')
    }
    setLoading(false)
  };
    
  /************************  Manage Use Effect **************************** */
  useEffect(() => {
    fetchBannerList();
  }, [paginationModel]);

  /************************  Table Column Manage **************************** */
  const columns = [
    { 
      field: 'imageUrl', 
      headerName: 'Banner', 
      headerAlign:'center',
      flex: 2,
      // filterable: false,
      sortable: false,
      // valueGetter: (params) => {
      //   // Join all subcategory titles into a single searchable string
      //   const title = params.row.title;
      //   const referenceType = params.row.referenceType;
      //   const issueDate = formatDateTime(params.row.issueDate,'date');
      //   const rewardValue = params.row.rewardValue;
      //   const walletType = params.row.walletType;
      //   const expireDate = formatDateTime(params.row.expireDate,'date');
      //   const maxRewardValue = params.row.maxRewardValue;
      //   return `${title} ${referenceType} ${issueDate} ${rewardValue} ${walletType} ${expireDate} ${maxRewardValue}`.toLowerCase();
      // },
      renderCell: (params) => (
        <Box sx={{ display: 'flex',alignItems:'center' ,width:'100%',p:1}}>
          <Box sx={{ width:'100%'}}>
            {params.row.imageUrl ? (
              <img 
              //   src={params.row.images} 
                src={`${process.env.REACT_APP_IMAGE_STORE_PATH}/${params.row?.imageUrl}`}
                alt={params.row.title}
                style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
              />
            ) : (
              <Skeleton variant="rectangular" width={35} height={35} animation={false} />
            )}
          </Box>
        
        </Box>
      ),
    },
    { 
      field: 'details', 
      headerName: 'Details', 
      headerAlign: 'center',sortable:false,
      filterable: false,
      flex:2,
      sortable: false,
      // valueGetter: (params) => {
      //   return params.row?.platforms.map(platform => platform).join(', ');
      // },
      renderCell: (params) => {   
        return (
          <Box sx={{width:'100%'}}>
            <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
              <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Title</Typography>
              <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
              <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row.title || 'N/A'}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
              <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Display On</Typography>
              <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
              <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row.platformName || 'N/A'}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
              <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Category</Typography>
              <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
              <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row.bannerCategory || 'N/A'}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
              <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Position</Typography>
              <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
              <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row.bannerPosition || 'N/A'}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
              <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Type</Typography>
              <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
              <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row.bannerType || 'N/A'}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
              <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Is Slider</Typography>
              <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
              <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row?.isSlider ? 'Yes' : 'No' || 'N/A'}</Typography>
            </Box>
            { params.row.bannerType == 'interactive' &&
              <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
                <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Link</Typography>
                <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
                <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row.appUrl || params.row.linkUrl || 'N/A'}</Typography>
              </Box>
            }
          </Box>
        );
      },
    },
    // { 
    //   field: 'bannerCategory', 
    //   headerName: 'Category', 
    //   headerAlign:'center',
    //   flex: 1.5,
    //   sortable: false,
    //   renderCell: (params) => (
    //     <Box sx={{ p: 1 ,textAlign:'center'}}>
    //       <Typography variant="body2" sx={{fontSize:'.65rem'}}>{params.row.bannerCategory}</Typography>
    //     </Box>
    //   ),
    // },
    {
      field: 'displayPeriod',
      headerName: 'Display Period',
      headerAlign:'center',
      flex: 1.5,
      filterable: false,
      sortable:false,
      valueGetter: (params) => {
        const startDate = params.row.issueDate ? formatDateTime(params.row.issueDate,'date'):'N/A';
        const endDate = params.row.expireDate ? formatDateTime(params.row.expireDate,'date'):'N/A';
        return `${startDate} to ${endDate}`;
        // return `${formatDateTime(params.row.issueDate,'date')} to ${formatDateTime(params.row.expireDate,'date')}`;
      },
      renderCell:(params)=>{
        return (
          <Box sx={{display:'flex',flexDirection:'column',gap:1}}>
            <Typography sx={{fontSize:'0.5rem'}}> <Box component={'span'} sx={{fontWeight:600}}>Start Date: </Box>{params.row.startDate ? formatDateTime(params.row.startDate):'N/A'}</Typography>            
            <Typography sx={{fontSize:'0.5rem'}}> <Box component={'span'} sx={{fontWeight:600}}>Expiry Date: </Box>{params.row.expireDate ? formatDateTime(params.row.expireDate):'N/A'}</Typography>
          </Box>
        )
      }
    },
    { 
      field: 'status', 
      headerName: 'Status', 
      headerAlign:'center',
      flex: .5,
      sortable: false,
      valueGetter: (params) => {
        return params.row.status == 'active' ? 'Active' : 'Inactive';
      } ,
      renderCell: (params) => {
        return(       
        <PermissionGuard feature='banner' permission='canEdit'>
          <Box sx={{display:'flex',flexDirection:'column',gap:1,alignItems:'center',width:'100%'}}>
              <Switch
                size='small'
                checked={params.row.status == 'active'}
                onChange={()=>handleStatusChange({status: params.row.status == 'active' ? 'inactive':'active'},params.row.id)}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': {
                      color: 'success.main',
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: 'success.main'
                  },
                  '& .MuiSwitch-switchBase': {
                      color: 'error.main',
                  },
                  '& .MuiSwitch-track': {
                      backgroundColor: 'error.main'
                  }
                }}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              <Typography
                variant="body2"
                size="small"
                sx={{
                  color: params.row?.status=='active' ? 'success.main' : 'error.main',
                  fontWeight: '600',
                  fontSize:'.65rem'
                }}
              >
                {params.row?.status == 'active' ? 'Active' : 'Inactive'}
              </Typography>
          </Box>
        </PermissionGuard>
        
      )},
    },
    {
      field:'createdAt',
      headerName:'Created On',
      headerAlign:'center',
      flex: 1,
      filterable: false,
      sortingOrder: ['asc', 'desc'],
      valueGetter: (params) => {
        return params.row.createdAt? formatDateTime(params.row.createdAt):'';
      },
      renderCell:(params)=>{
        return (
          <Typography sx={{fontSize:'0.55rem'}}>{params.row.createdAt? formatDateTime(params.row.createdAt):''}</Typography>
        )
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      headerAlign:'center',
      flex: .5,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ p: 1, display: 'flex',flexDirection:'column',gap:1 ,justifyContent: 'center',alignItems:'center',width:'100%' }}>
          <IconButton 
            sx={{color: "blue",}}
            onClick={() => window.open(`/marketing/banner/view/${params.row.id}`, '_blank')} 
            size="small">
            <RemoveRedEyeIcon sx={{fontSize:'0.95rem'}}/>
          </IconButton>
          <PermissionGuard feature='banner' permission='canEdit'>
            <IconButton onClick={() => window.open(`/marketing/banner/${params.row.id}`,'_blank')} size="small" color='warning'>
              <Edit sx={{fontSize:'0.95rem'}}/>
            </IconButton>
          </PermissionGuard>
          {/* <IconButton onClick={() => deleteService(params.row.id)} size="small">
            <DeleteIcon />
          </IconButton> */}
        </Box>
      ),
    },
  ];

  const handleStatusChange = async (data,bannerId) => {
      // console.log ("required customer data for status change:",data);
      const result = await Swal.fire({
        text: "Do you want to Change Banner Status now?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Change now!',
        cancelButtonText: 'No, Cancel',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: false,
      });
    
      if (result.isConfirmed) {
        try {
          // Show loading state
          Swal.fire({
            title: 'Processing...',
            text: 'Please wait while we update the banner status',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
    
          // Make the API call
          const statusChangeResponse = await BannerServices.changeStatus(bannerId);
          // console.log("customer account status change response:", statusChangeResponse);
    
          // Close loading dialog and show success/error message
          if (statusChangeResponse.success == '1') {
            await fetchBannerList();
            await Swal.fire({
              icon: 'success',
              title: 'Success!',
              text: statusChangeResponse.message || 'Banner Status updated successfully',
              timer: 1500
            });
            
            return true;
          } else {
            await Swal.fire({
              icon: 'error',
              title: 'Error!',
              text: statusChangeResponse.message || 'Failed to update banner status'
            });
            return false;
          }
    
        } catch (error) {
          // console.error("Error changing customer account status:", error);
          await Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'An error occurred while updating the banner status'
          });
          return false;
        }
      } else {
        return false;
      }
    };

  /************************  Action Handler Related table row **************************** */   
  const handlePaginationChange = (newPagination) => {
      setPaginationModel({
          ...paginationModel,
          page: newPagination.page,
          pageSize: newPagination.pageSize
      });
  }
  /************************  Advance Filter **************************** */
    
  
  const [clearMultiFilter, setClearMultiFilter] = useState(false);
  const filterableColumns = [
    // {
    //   key: 'name',
    //   label: 'Customer Name',
    //   type: 'text'
    // },
    // {
    //   key: 'mobileNumber',
    //   label: 'Mobile Number',
    //   type: 'number'
    // },
    // {
    //   key:'email',
    //   label:'Email',
    //   type:'email'
    // },
    // {
    //   key:'age',
    //   label:'Age',
    //   type:'number'
    // },
    {
      key: 'platformName',
      label: 'Platform',
      type: 'select',
      options: [
        // 'Customer-App','SE-App','Customer-Web','SE-Web'
        { value: 'Customer-App', label: 'Customer-App' },
        { value: 'SE-App', label: 'SE-App' },
        { value: 'Customer-Web', label: 'Customer-Web' },
        { value: 'SE-Web', label: 'SE-Web' }
      ]
    },
    {
      key: 'bannerCategory',
      label: 'Category',
      type: 'select',
      options: [
        // 'Customer-App','SE-App','Customer-Web','SE-Web'
        { value: 'Homescreen', label: 'Homescreen' },
        // { value: 'SE-App', label: 'SE-App' },
        // { value: 'Customer-Web', label: 'Customer-Web' },
        // { value: 'SE-Web', label: 'SE-Web' }
      ]
    },
    // {
    //   key: 'referenceType',
    //   label: 'Program Type',
    //   type: 'select',
    //   options: [
    //     { value: 'REFERAL', label: 'REFERAL' },
    //     { value: 'BOOKING', label: 'BOOKING' },
    //     { value: 'BOOKINGEARN', label: 'BOOKINGEARN' },
    //     { value: 'JOINING', label: 'JOINING' },
    //     { value: 'TOPUP', label: 'TOPUP' },
    //     { value: 'WITHDRAW', label: 'WITHDRAW' },
    //     { value: 'REWARD', label: 'REWARD' },
    //     { value: 'BONUS', label: 'BONUS' }
    //   ]
    // },
    // {
    //   key: 'isProvider',
    //   label: 'For',
    //   type: 'select',
    //   options: [
    //     { value: 'true', label: 'Service Expert' },
    //     { value: 'false', label: 'Customer' }
    //   ]
    // },
    {
      key: 'status',
      label: 'Is Active',
      type: 'select',
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'In-active' }
      ]
    },
    {
      key: 'isSlider',
      label: 'Slider',
      type: 'select',
      options: [
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' }
      ]
    },
    {
      key: 'isExpired',
      label: 'Is Expired',
      type: 'select',
      options: [
        { value: 'true', label: 'expired' },
        { value: 'false', label: 'not-expired' }
      ]
    },
    {
      key: 'startDate',
      label: 'Start Date',
      type: 'date'
    },
    {
      key: 'expireDate',
      label: 'Expiry Date',
      type: 'date'
    },
    {
      key: 'createdAt',
      label: 'Created Date',
      type: 'date'
    }
  ];
  const handleApplyFilter = (filterData) => {
    // Process filter data
    console.log(filterData);
    setPaginationModel({
      ...paginationModel,
      page: 0, // Reset to first page when applying new filters
      filters: {
        ...paginationModel.filters,
        // Convert MultiColumnFilter options to a format your backend can understand
      filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
      }
    });
  }

  /************* quick search related **************/
  // Properly structured filter model
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: []
  });

  /******************* Sorting model  ******************************/
  const [sortModel, setSortModel] = useState([
    {
      field: paginationModel.filters.sortBy,
      sort: paginationModel.filters.sortType,
    },
  ]);

  const handleSortingChange = (newSortModel)=>{
    console.log("new sort model",newSortModel);
    if (newSortModel && newSortModel.length > 0) {
      setSortModel(newSortModel);
      setPaginationModel(prev => ({
        ...prev,
        filters: {
          ...prev.filters,
          sortBy: newSortModel[0].field,
          sortType: newSortModel[0].sort
        }
      }));
    }
    // else{
    //   setSortModel([{
    //     field: 'createdAt',
    //     sort: 'asc',
    //   }]);
    //   setPaginationModel(prev => ({
    //     ...prev,
    //     filters: {
    //       ...prev.filters,
    //       sortBy: 'createdAt',
    //       sortType: 'asc'
    //     }
    //   }));
    // }
  }
  return ( 
    <Box sx={{ overflow: "auto" }}>
      {loading && <Loading/>}
        <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff", borderRadius: '.5rem' }}>
          <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between',alignItems:'center',px:'1%' }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <MultiColumnFilter
                filterableColumns={filterableColumns}
                onApplyFilter={handleApplyFilter}
                externalClear={clearMultiFilter}
              />
              {/* <ExportAll
                paginationModel={paginationModel} 
                columns={columns} 
                // statusOptions={statusOptions} 
              /> */}
            </Box>
            
            <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} />
          </Box>
          <DataGrid
            rows={list}
            columns={columns.map((col) => ({
              ...col,
              // flex: col.flex || 1, // Ensure columns resize dynamically
              minWidth: isSm && (col.minWidth || 200), // Set a minimum width to avoid overlap
            }))}
            getRowId={(row) => row.id}
            //checkboxSelection={true}
            rowCount={allRowCount}  // Use the length of the filtered list
            pageSizeOptions={[5, 10, 20, 50, 100]}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={handlePaginationChange}

            filterModel={filterModel}

            sortingMode="server"
            sortModel={sortModel}                  
            onSortModelChange={handleSortingChange}
            disableMultiSort={true}

            loading={loading}

            disableColumnMenu
            disableRowSelectionOnClick
            slots={{
                // toolbar: GridToolbar,                        
                loadingOverlay: Loading,
                noRowsOverlay: NoRowsLayout,
            }}
            autoHeight
            getRowHeight={() => 'auto'}
            sx={{
                '& .MuiDataGrid-cell': {
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
                },
                '& .MuiDataGrid-columnHeaders': {
                  borderBottom: '2px solid rgba(224, 224, 224, 1)',
                  borderTop: '2px solid rgba(224, 224, 224, 1)',
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  p:0,
                  height: 'fit-content',
                  minHeight:'0 !important',
                  height:'2rem'
                },
                '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                '&:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
                },
                '& .MuiDataGrid-row': {
                '&:last-child .MuiDataGrid-cell': {
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnSeparator': {
                display: 'none',
                },
            }}
            />
        </Box>
    </Box>
  );
}

export default AllBanners;
